import { createFileRoute } from "@tanstack/react-router"
import CollectionCapacityTab from "~/components/purchase-plan/CollectionCapacityTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/collection/$collectionId/_layout/capacity",
)({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Fashion Supply Plan Detail - Capacity Planning")

  return <CollectionCapacityTab />
}
